import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '@shared/core';
import { UserRole } from '@shared/core/types';

type Logic = 'some' | 'every';

// todo: переписать на структурную директиву
@Pipe({
  name: 'hasPermission',
})
export class HasPermissionPipe implements PipeTransform {
  constructor(private userService: UserService) {}

  transform(roles: UserRole | UserRole[], logic: Logic = 'some'): boolean {
    if (!Array.isArray(roles)) {
      roles = [roles];
    }

    if (logic === 'every') {
      return roles.every(role => this.userService.hasRole(role));
    }

    return roles.some(role => this.userService.hasRole(role));
  }
}
